import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilityBasicInfo } from 'src/app/models/utility.model';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
})
export class LandingComponent implements OnInit {
  show: boolean = false;
  state = 'closed';
  utility: UtilityBasicInfo = new UtilityBasicInfo();
  utilityLogo: string = '';
  cookieConsentRequired?: boolean;
  constructor(
    private utilityService: UtilityService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    var utilityRoute = this.route.snapshot.paramMap.get('utility') || '';
    if (utilityRoute) {
      this.tryGetUtilityByName(utilityRoute.replace(new RegExp("-", "g"), " "));
    } else this.router.navigate(['']);
  }

  showSlider() {
    this.show = false;
  }

  tryGetUtilityByName(name: string) {
    this.utilityService.getByName(name).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK' && responseData.data) {
          this.utility = responseData.data;
          this.cookieConsentRequired = JSON.parse(responseData.data.cookieConsentRequired ?? '');
          localStorage.setItem('cookieConsentRequired', responseData.data.cookieConsentRequired);
          this.fetchKycConfiguration();
        } else {
          this.router.navigate(['']);
        }
      },
      error: (_) => {
        this.router.navigate(['']);
      },
    });
  }

  fetchKycConfiguration() {
    this.utilityService.getKycConfiguration(this.utility.id).subscribe({
      next: (response) => {
        const data = response.body?.data;
        if (data) {
          if (data.utilityLogo) {
            this.utilityLogo = data.utilityLogo;
            localStorage.setItem('kycUtilityLogo', data.utilityLogo);
          }
          if (data.utilityName) {
            localStorage.setItem('kycUtilityName', data.utilityName);
          }
        }
      }
    });
  }
}
